import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ArtifactRenderer } from '../artifacts/ArtifactRenderer';
import { normalizeMarkdownTables } from '@/utils/markdown';
import type { Artifact } from '@/types';

interface StreamingMessageProps {
  content: string;
  artifacts: Artifact[];
  thinkingStatus?: string | null;
}

export function StreamingMessage({ content, artifacts, thinkingStatus }: StreamingMessageProps) {
  return (
    <div className="py-4">
      {thinkingStatus && !content && (
        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-2">
          <ThinkingDots />
          <span>{thinkingStatus}</span>
        </div>
      )}
      <div className="prose prose-sm dark:prose-invert max-w-none text-foreground">
        {content ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {normalizeMarkdownTables(content)}
          </ReactMarkdown>
        ) : !thinkingStatus ? (
          <div className="flex items-center gap-2 text-muted-foreground">
            <ThinkingDots />
          </div>
        ) : null}
      </div>

      {artifacts.length > 0 && (
        <div className="mt-4 space-y-4">
          {artifacts.map((artifact) => (
            <ArtifactRenderer key={artifact.id} artifact={artifact} />
          ))}
        </div>
      )}
    </div>
  );
}

function ThinkingDots() {
  return (
    <div className="flex gap-1">
      <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:-0.3s]" />
      <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:-0.15s]" />
      <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground" />
    </div>
  );
}
